package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.finance.RatesSnapshotDto
import com.evoapps.evoshift.domain.model.RatesSnapshot

class RatesSnapshotMapper {

    fun toDomain(dto: RatesSnapshotDto): RatesSnapshot {
        return RatesSnapshot(
            rateUsed = dto.rateUsed,
            employerRateUsed = dto.employerRateUsed,
            contractType = dto.contractType,
            currency = dto.currency,
            market = dto.market,
            plannedHours = dto.plannedHours,
            nightHours = dto.nightHours
        )
    }

    fun toDto(domain: RatesSnapshot): RatesSnapshotDto {
        return RatesSnapshotDto(
            rateUsed = domain.rateUsed,
            employerRateUsed = domain.employerRateUsed,
            contractType = domain.contractType,
            currency = domain.currency,
            market = domain.market,
            plannedHours = domain.plannedHours,
            nightHours = domain.nightHours
        )
    }
}
